module.exports = __webpack_public_path__ + "56040e58aa98ea7d205ee20975b37b4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000WM1.png
// module id = 1460
// module chunks = 0